// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demand-table-row[data-v-c041d1ce]{background-color:#141414;padding:5px 10px;cursor:pointer}.demand-table-row[data-v-c041d1ce]:hover{background-color:#444}.demand-table-row-active[data-v-c041d1ce]{background-color:#2d8cf0;padding:5px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
